var cilParagraph = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M440,64H208a128,128,0,0,0,0,256h56V448H376V96h64ZM264,288H208a96,96,0,0,1,0-192h56Zm80,128H296V96h48Z' class='ci-primary'/>"];

export { cilParagraph };

